import React, { useEffect, useState } from 'react';
import Icon from '../../../../component/Icon';
import { burger } from '../../../../assets/images/images';
import { useSelector, useDispatch } from 'react-redux';
import { Bars } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import * as actionCreators from '../../../../store/actionCreators'

function EditProduct() {
  const state = useSelector((state) => state.product);
  const dispatch = useDispatch()
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState(0);
  const [inStock, setInStock] = useState(0);
  const [createdBy, setCreatedBy] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const curProduct = state.backend.selectedProduct;
    if (!curProduct) {
      navigate(-2);
    }
    setTitle(curProduct.title);
    setDescription(curProduct.description);
    setPrice(curProduct.price);
    setCreatedBy(
      `${curProduct.created_by?.firstname} ${curProduct.created_by?.lastname}`
    );
  }, []);

  const submitHandler = () => {
    const data = {
      title,
      description,
      price,

    }
    dispatch(actionCreators.editProduct(data, ))
  }

  return (
    <div>
      {/* HEADER */}
      <div className='flex items-center ml-6 gap-2 mb-4'>
        <Icon name='edit' className='w-5 h-5 fill-greySecondary' />
        <h2 className='text-2xl font-[500] text-greySecondary'>Edit Product</h2>
      </div>
      {/* PRODUCT CREATED BY ... */}
      <div className='flex gap-4 ml-8 font-[300] mb-8 text-sm text-greySecondary'>
        <div className='flex items-center gap-2'>
          <h2 className='font-[400]'>Created By: </h2>
          <h3>
            {/* {product.created_by.firstname} {product.created_by.lastname} */}
            {createdBy ? createdBy: null}
          </h3>
        </div>
        <div className='flex items-center gap-2'>
          <h2 className='font-[400]'>Modified By: </h2>
          <h3>Yashu Neupane</h3>
        </div>
        <div className='flex items-center gap-2'>
          <h2 className='font-[400]'>Modified Date: </h2>
          <h3>2022/03/12</h3>
        </div>
      </div>

      {/* DESCRIPTION */}
      <div className='flex rounded-2xl gap-16 drop-shadow-xl w-[90%] mx-auto bg-white p-8'>
        {/* LEFT */}
        <div className='flex-1'>
          {/* <ProductCard /> */}
          <img
            src={burger}
            alt='product'
            className='block w-full h-full object-contain'
          />
        </div>
        {/* RIGHT */}
        <div className='' style={{ flex: 2 }}>
          <h2 className='font-[500] text-darkPrimary mb-2 text-xl'>Title</h2>
          <h3 className='font-Aclonica mb-4  font-[100] text-xs text-greySecondary'>
            Main Course
          </h3>
          <form>
            <div className='flex gap-4 items-stretch'>
              <input
                type='text'
                className='block text-greyPrimary outline-transparent focus:border-2 focus:border-greyPrimary border-2 p-2 flex-1 rounded-md'
                placeholder='Product name'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <select style={{
                padding: '2px',
                border: 'none',
                backgroundImage:'url("http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png")',
                backgroundPosition:'right center',
                backgroundRepeat: 'no-repeat'
              }} className='block text-greyPrimary flex-1 p-2 rounded-md'>
                <option>Burger</option>
                <option>Pasta</option>
                <option>Meat Balls</option>
              </select>
            </div>
            <div className='flex gap-4 items-stretch mt-2'>
              <input
                type='number'
                className='block text-greyPrimary outline-transparent focus:border-2 focus:border-greyPrimary border-2 p-2 flex-1 rounded-md'
                placeholder='Price'
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
              <select
                value={inStock}
                onChange={(e) => setInStock(e.target.value)}
                className='block text-greyPrimary flex-1 p-2 rounded-md'
              >
                <option value={1}>In Stock</option>
                <option value={0}>Out of Stock</option>
              </select>
            </div>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={5}
              className='block mt-4 w-full text-greyPrimary outline-transparent focus:border-2 focus:border-greyPrimary border-2 p-2 flex-1 rounded-md'
            ></textarea>
          </form>

          <button className='flex gap-2 items-center mt-4 bg-blue-500 p-2  rounded-md text-white'>
            <Icon name='edit' className='w-4 h-4 fill-white' />
            <h2 className='font-[600] text-sm'>Edit product</h2>
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditProduct;
